import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MapPin, Phone, Clock, Navigation, Search } from "lucide-react";
import { api } from "@/lib/api";
import { track } from "@/lib/analytics";
import { MapView } from "@/components/MapView";

export const DealerLocator = () => {
  const [dealers, setDealers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = (query = "") => {
    setLoading(true);
    api.get("/dealers", { params: query ? { q: query } : {} })
      .then((r) => setDealers(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const doSearch = (e) => { e?.preventDefault(); track("dealer_search", { q }); load(q); };

  return (
    <div data-testid="dealer-locator">
      <form onSubmit={doSearch} className="flex flex-col sm:flex-row gap-3 mb-8">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
          <Input placeholder="Città, provincia o CAP..." value={q} onChange={(e) => setQ(e.target.value)} className="h-14 text-lg pl-11" data-testid="dealer-search-input" />
        </div>
        <Button type="submit" className="h-14 px-8 text-lg font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="dealer-search-button">
          Trova il centro più vicino
        </Button>
      </form>

      {loading ? <p className="text-slate-500">Caricamento...</p> : (
        <>
          {dealers.length > 0 && (
            <div className="mb-8">
              <MapView points={dealers.map((d) => ({ id: d.id, lat: d.latitude, lng: d.longitude, title: d.dealer_name, subtitle: `${d.city} (${d.province})` }))} height={360} />
            </div>
          )}
          <div className="grid md:grid-cols-2 gap-5">
          {dealers.length === 0 && <p className="text-slate-500 col-span-2">Nessun centro trovato. Prova con un'altra ricerca o <Link to="/contatti" className="underline text-emerald-800">contattaci</Link>.</p>}
          {dealers.map((d) => (
            <div key={d.id} className="rounded-2xl bg-white border border-slate-200 p-6 hover:shadow-md transition-shadow" data-testid={`dealer-card-${d.slug}`}
              onMouseEnter={() => track("dealer_view", { dealer: d.slug })}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>{d.dealer_name}</h3>
                  <p className="text-slate-500 text-sm mt-0.5">{d.city} ({d.province}) · {d.region}</p>
                </div>
                {d.test_drive_available && <span className="text-xs font-bold text-emerald-800 bg-emerald-100 px-2.5 py-1 rounded-full whitespace-nowrap">Ordine online</span>}
              </div>
              <div className="mt-4 space-y-2 text-slate-600 text-sm">
                <p className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0 text-emerald-700" /> {d.address}</p>
                <p className="flex items-center gap-2"><Phone size={16} className="text-emerald-700" /> <a href={`tel:${d.telephone}`} className="hover:text-emerald-800">{d.telephone}</a></p>
                <p className="flex items-start gap-2"><Clock size={16} className="mt-0.5 shrink-0 text-emerald-700" /> {d.opening_hours}</p>
              </div>
              <div className="mt-5 flex gap-2">
                <Link to={`/rivenditori/${d.city.toLowerCase()}/${d.slug}`} className="flex-1">
                  <Button variant="outline" className="w-full h-11 font-semibold" data-testid={`dealer-detail-${d.slug}`}>Dettagli</Button>
                </Link>
                <a href={`https://www.google.com/maps/search/?api=1&query=${d.latitude},${d.longitude}`} target="_blank" rel="noreferrer" className="flex-1">
                  <Button className="w-full h-11 font-semibold gap-2 text-white" style={{ backgroundColor: "var(--sc-emerald)" }}><Navigation size={16} /> Indicazioni</Button>
                </a>
              </div>
            </div>
          ))}
          </div>
        </>
      )}
    </div>
  );
};
